angular
    .module('tradersyard')
    .config([
        'uiMask.ConfigProvider',
        function (uiMaskConfigProvider) {
            uiMaskConfigProvider.allowInvalidValue(false);
            uiMaskConfigProvider.clearOnBlur(false);
            uiMaskConfigProvider.maskDefinitions({ T: /(A|P)/, t: /(a|p)/ });
        },
    ])
    .factory('datetime-common', [
        function () {
            var is12 = /a/i.test(moment.localeData()._longDateFormat.LT);
            var is24 = !is12;

            var $format = {
                date: 'LL',
                time: is12 ? 'hh:mm A' : 'HH:mm',
            };

            var $default = {
                start: moment().add(1, 'h'),
                end: moment().add(2, 'h'),
            };

            var $factory = {
                is12: is12,
                is24: is24,
                format: $format,
                config: {
                    dateFormat: $format.date,
                    minDate: moment().subtract(1, 'days'),
                },
                gather: function (obj) {
                    date = moment(obj.date, $format.date);
                    time = obj.time ? obj.time.split(':') : is12 ? ['12', '00 AM'] : ['00', '00'];

                    if (is12 === true) {
                        var ampm = time[1].split(' ');

                        date.set({
                            hour: (ampm[1] === 'AM' ? 0 : 12) + (parseInt(time[0], 10) % 12),
                            minute: parseInt(ampm[0], 10),
                        });
                    } else {
                        date.set({
                            hour: parseInt(time[0], 10),
                            minute: parseInt(time[1], 10),
                        });
                    }

                    return date;
                },
                parse: function (obj, date, time) {
                    return {
                        date: obj.format(date ? date : $format.date),
                        time: obj.format(time ? time : $format.time),
                    };
                },
                rebuild: function (obj) {
                    return $factory.parse($factory.gather(obj));
                },
                default: $default,
                is: {
                    after: function (src, dest) {
                        $factory.diff(src, dest);
                    },
                    before: function (src, dest) {},
                },
                diff: function (src, dest) {
                    return dest.diff(src);
                },
                duration: function (src, dest) {
                    return moment.duration($factory.diff(src, dest));
                },
            };

            return $factory;
        },
    ])
    .controller('webinar-create-ctrl', [
        '$scope',
        'graph-webinar-factory',
        'datetime-common',
        '$flex',
        'graph-api-client',
        '$rootScope',
        function ($scope, webinarFactory, $common, $flex, $client, $root) {
            $scope.$error = {};
            $scope.buffer = {};
            $scope.$datetime = $common;
            // $scope.duration     = 0;
            $scope.diffed = 0;
            $scope.queue = 0;
            $scope.inviteModel = [];
            $scope.groups = [];
            $scope.selectSettings = { styleActive: true, displayProp: 'name', showUncheckAll: false };
            $scope.groupPage = 1;
            $scope.privacyDisabled = false;

            this.init = function () {
                $scope.getGroups();
            };

            $scope.getGroups = function () {
                $client.get('me/groups?filter=my&limit=100&page=' + $scope.groupPage).then(function ($response) {
                    if ($response.data.state === 0) {
                        $scope.groups = $scope.parseGroups($response.data.data);
                        $scope.presetGroup();
                    }
                });
            };

            $scope.parseGroups = function (response) {
                var groups = [];
                response.forEach(function (group) {
                    groups.push(group);
                });
                return groups;
            };

            $scope.presetGroup = function () {
                var param = new URLSearchParams(window.location.search.slice(1));
                var groupId = param.get('group');

                if (groupId) {
                    $scope.groups.forEach(function (group) {
                        if (group.id == groupId) {
                            $scope.inviteModel = [group];
                            $scope.node.privacy = group.privacy;
                            $scope.privacyDisabled = true;
                        }
                    });
                }
            };

            $scope.calculate = function (moved) {
                var started_at = $common.gather($scope.node.started_at),
                    ended_at = $common.gather($scope.node.ended_at);

                // console.log($scope.diffed / 1000);

                if (moved === true) ended_at = started_at.clone().add($scope.diffed, 's');

                $scope.node.started_at = $common.parse(started_at);

                $scope.node.ended_at = $common.parse(ended_at);

                if ($scope.form.started_at_time) {
                    $scope.form.started_at_time.$setValidity('future', $common.diff(moment(), started_at) > 0);
                }

                $scope.form.languages.$setValidity('languages', Object.values($scope.languages).indexOf(true) != -1);

                if ($scope.node.technology === 'choop-chat') {
                    $scope.node.technology_url = '';
                }

                $scope.diffed = $common.diff(started_at, ended_at) / 1000;

                if ($scope.form.ended_at_time) {
                    $scope.form.ended_at_time.$setValidity('future', $scope.diffed > 0);
                }

                if (['daily', 'weekly', 'every-two-weeks', 'monthly'].indexOf($scope.node.occurs) !== -1) {
                    var ended_at_buff = ended_at;
                    ended_at = started_at.clone();
                    ended_at.hour(ended_at_buff.hour());
                    ended_at.minutes(ended_at_buff.minutes());
                    $scope.duration = $common.duration(started_at, ended_at).humanize();
                } else {
                    $scope.duration = $common.duration(started_at, ended_at).humanize();
                }

                switch ($scope.node.occurs) {
                    case 'daily':
                        $scope.executions = Math.ceil($scope.diffed / 60 / 60 / 24);
                        break;

                    case 'weekly':
                        $scope.executions = Math.ceil($scope.diffed / 60 / 60 / 24 / 7);
                        break;

                    case 'every-two-weeks':
                        $scope.executions = Math.ceil($scope.diffed / 60 / 60 / 24 / 14);
                        break;

                    case 'monthly':
                        $scope.executions = Math.ceil($scope.diffed / 60 / 60 / 24 / 30);
                        break;
                }
            };

            $scope.addSession = function () {
                var lastExecution = $scope.node.executions[$scope.node.executions.length - 1];

                var started_at = $common.gather(lastExecution.started_at);
                started_at.add(1, 'd');

                var ended_at = $common.gather(lastExecution.ended_at);
                ended_at.add(1, 'd');

                $scope.node.executions.push({
                    id: 0,
                    started_at: $common.parse(started_at),
                    ended_at: $common.parse(ended_at),
                });
            };

            $scope.removeSession = function (index) {
                $scope.node.executions.splice(index, 1);
            };

            $scope.validate = function (data) {
                $scope.calculate();

                // if (data.occurs === 'daily' || data.occurs === 'weekly' || data.occurs === 'every-two-weeks' || data.occurs === 'monthly') {
                //   data.ended_at.time = data.started_at.time;
                // }

                var started_at, ended_at;

                if (data.occurs === 'one-session' || data.occurs === 'custom') {
                    started_at = $common.gather(data.started_at);
                    ended_at = $common.gather({ date: data.started_at.date, time: data.ended_at.time });
                } else {
                    started_at = $common.gather(data.started_at);
                    ended_at = $common.gather(data.ended_at);
                }

                // if (data.occurs === 'one-session') {
                //   ended_at = started_at.clone();
                //   ended_at.add(1, 'h');
                // }

                var diff = $common.diff(started_at, ended_at);

                var executions = [];

                if (data.occurs === 'custom') {
                    executions = data.executions.map(function (execution) {
                        return {
                            id: 0,
                            started_at: $common.gather(execution.started_at),
                            ended_at: $common.gather({
                                date: execution.started_at.date,
                                time: execution.ended_at.time,
                            }),
                        };
                    });
                }

                if (diff > 0) {
                    $scope.buffer = {
                        name: data.name,
                        description: data.description,
                        occurs: data.occurs,
                        started_at: started_at.toISOString(),
                        ended_at: ended_at.toISOString(),
                        languages: data.languages,
                        privacy: data.privacy,
                        technology: data.technology,
                        technology_url: data.technology_url,
                        executions: executions,
                        pricing: data.pricing,
                    };

                    return true;
                } else {
                    return false;
                }
            };

            /**
             * @param {PayToJoinPricingFormData} formData
             */
            $scope.onEventPricingChange = function onEventPricingChange(formData) {
                $scope.pricingFormData = formData;
            };

            $scope.submit = function () {
                if ($scope.validate($scope.node) === true && $scope.queue === 0) {
                    $scope.queue = 1;
                    $scope.create($scope.buffer);
                }
            };

            /**
             * @param {PayToJoinPricingFormData} formData
             */
            const mapPricingFormDataToPayload = (formData) => {
                switch (formData.paymentType.key) {
                    case 'free':
                        return;
                    default:
                        return {
                            wc_product_id: formData.product.productId,
                            is_recurring: formData.paymentType.isRecurring,
                        };
                }
            };

            $scope.create = function (data) {
                if ($scope.pricingFormData) {
                    data.pricing = mapPricingFormDataToPayload($scope.pricingFormData);
                }

                if ($scope.exhibition) {
                    data.exhibition_id = $scope.exhibition.id;
                    data.speaker_hall_id = $scope.exhibition.speaker_hall_id;
                    data.sponsoring = $scope.node.sponsoring;
                }

                webinarFactory.create(data).then(function (response) {
                    if (response.data.state === 0) {
                        webinarFactory.getMyProfile().then(function (profile) {
                            if (profile.data.data.google_sync) {
                                webinarFactory.googleCalendarSync(response.data.data);
                            }
                        });

                        var inviteData = {
                            entry: 'webinar',
                            entryId: response.data.data.id,
                            groups: $scope.inviteModel,
                        };
                        $root.$broadcast('invite-form-open');
                        $root.$broadcast('invite:custom', inviteData);
                        $scope.$on('invite-form-close', function () {
                            window.location.replace('/webinar/' + response.data.data.id);
                        });
                    } else {
                        $scope.errors = response.data.data;
                        $scope.queue = 0;
                    }
                });
            };

            $scope.reserveToken = function (data) {
                $scope.create(data);
            };

            $scope.orderToken = '';
            $scope.exhibition = undefined;

            $scope.massInvite = function (webinarId) {
                return new Promise(function (resolve) {
                    if (!$scope.inviteModel) {
                        resolve();
                    }

                    var promises = [];

                    $scope.inviteModel.forEach(function (group) {
                        promises.push($client.post(['webinar', webinarId, 'mass.invite', 'using.group.' + group.id]));
                    });

                    Promise.all(promises).then(function ($response) {
                        resolve();
                    });
                });
            };

            $scope.languages = {
                en: true,
                de: false,
                ru: false,
            };

            $scope.langcheck = function (code) {
                var index = $scope.node.languages.indexOf(code);

                if (index === -1) {
                    $scope.node.languages.push(code);
                } else {
                    $scope.node.languages.splice(index, 1);
                }
            };

            $scope.node = {
                name: '',
                description: '',
                started_at: $common.parse($common.default.start),
                ended_at: $common.parse($common.default.end),
                languages: ['en'],
                occurs: 'one-session',
                privacy: 'public',
                stream_url: null,
                technology: 'choop-chat',
                technology_url: '',
                sponsoring: 'free',
                executions: [
                    {
                        id: 0,
                        started_at: $common.parse($common.default.start),
                        ended_at: $common.parse($common.default.end),
                    },
                ],
            };

            if (angular.isObject($flex.data.node)) {
                angular.extend($scope.node, $flex.data.node);

                if (angular.isArray($flex.data.node.languages) && $flex.data.node.languages.length > 0) {
                    var languages = [];

                    $scope.node.languages.forEach(function (code) {
                        languages.push(code.code);
                        $scope.languages[code.code] = true;
                    });

                    $scope.node.languages = languages;
                } else {
                    $flex.data.node.languages = ['en'];
                }
            }

            if (angular.isObject($flex.data.exhibition)) {
                $scope.exhibition = $flex.data.exhibition;

                $scope.node.started_at.time = moment($scope.exhibition.start_time, 'HH:mm').format('HH:mm A');
                $scope.node.started_at.date = moment($scope.exhibition.start_date, 'YYYY-MM-DD').format('LL');
                $scope.node.executions[0].started_at.time = $scope.exhibition.start_time;
                var endedAt = moment($scope.node.started_at.date + ' ' + $scope.exhibition.start_time, 'LL HH:mm A');

                endedAt = endedAt.add($scope.exhibition.duration, 'm');

                $scope.node.ended_at = $common.parse(endedAt);
                $scope.node.executions[0].ended_at = $common.parse(endedAt);
            }

            $scope.is12 = $common.is12;
            $scope.is24 = $common.is24;

            setTimeout($scope.calculate, 0);

            this.init();
            // $scope.duration = $common.duration(
            //     $common.default.start, $common.default.end
            // ).humanize();
        },
    ]);
